import React from "react";

const ArrowDown = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title className="sr-only">Arrow down</title>
      <mask
        id="mask0_1706_19472"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-1"
        width="15"
        height="16"
      >
        <rect
          x="-0.000244141"
          y="14.0001"
          width="14.0002"
          height="14.0002"
          transform="rotate(-90 -0.000244141 14.0001)"
          className="fill-[#D9D9D9] dark:fill-white"
        />
      </mask>
      <g mask="url(#mask0_1706_19472)">
        <path
          d="M12.6313 4.66681L6.99981 10.2983L1.36836 4.66681L2.19627 3.8389L6.99981 8.64259L11.8034 3.8389L12.6313 4.66681Z"
          className="fill-black dark:fill-white"
        />
      </g>
    </svg>
  );
};

export default ArrowDown;
